import Text from 'components/Text/Text';
import React from 'react';
import classNames from 'classnames';
import DnDList from './components/DnDList/DnDList';
import style from './ChangePositionList.module.scss';

const ChangePositionList: React.FC = () => {
	const nameHeadingClasses = classNames(style.name, style.heading);
	const restaurantHeadingClasses = classNames(style.restaurant, style.heading);
	const customerHeadingClasses = classNames(style.customer, style.heading);
	const isDisabledHeadingClasses = classNames(style.isDisabled, style.heading);
	const priceHeadingClasses = classNames(style.price, style.heading);

	return (
		<div className={style.container} data-test="ChangePositionList">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="nameOfModifierLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantHeadingClasses}
					translationNameSpace="listing"
					translationKey="restaurantLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={customerHeadingClasses}
					translationNameSpace="listing"
					translationKey="customerLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={isDisabledHeadingClasses}
					translationNameSpace="listing"
					translationKey="isDisabledLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={priceHeadingClasses}
					translationNameSpace="listing"
					translationKey="priceLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			<DnDList />
		</div>
	);
};

export default ChangePositionList;
